import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faBars } from '@fortawesome/free-solid-svg-icons'
import { useLocation } from 'react-router-dom'
import qpLogo from '../../images/quinto_puoi.svg'
import bsLogo from '../../images/banca_sistema_new.svg'
import qpLogoRedux from '../../images/quinto_puoi_redux.svg'
import bsLogoRedux from '../../images/banca_sistema_redux_new.svg'
import greenNumberIcon from '../../img/green_number.svg'

const Header = () => {
  let [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  /**
   * 1360px, e la soglia non e' arbitraria: e' la larghezza minima a cui i due
   * loghi dell'header, che sono link (home e bancasistema.it), raggiungono i
   * 24x24px richiesti da WCAG 2.5.8.
   *
   * Il contenitore del logo e' `flex: 0 1 auto` e si comprime per far posto al
   * menu, perche' sotto quella larghezza non c'e' spazio per logo, 8 voci, CTA
   * e logo Banca Sistema a dimensione piena. Misurato sul logo QuintoPuoi:
   *
   *   1200-1240px   0x0  (invisibile)      1360px    72x38  conforme
   *   1280px       22x21 sotto soglia      1400px    96x48
   *   1320px       47x27 (BS 28x21)        1440px   121x59
   *
   * Bloccare la compressione non basterebbe: il menu uscirebbe dal viewport e
   * riaprirebbe 1.4.10. Sotto i 1360 si rende quindi il ramo mobile, dove i
   * loghi stanno a 143x30 e 72x10 e niente si comprime.
   *
   * Era un difetto preesistente, identico su main: non l'ha introdotto la
   * remediation, la remediation lo chiude.
   */
  const isMobile = useMediaQuery({ query: '(max-width: 1360px)' })

  const [isHeaderShrink, setIsHeaderShrink] = useState<boolean>(false)

  const [headerBoxShadow, setHeaderBoxShadow] = useState<string>('')

  const openHamburgerMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleScroll = () => {
    if (window.scrollY >= 200) {
      setHeaderBoxShadow('rgb(9 51 64 / 27%) 0px 4px 9px 0px')
      setIsHeaderShrink(true)
    }
    if (window.scrollY === 0) {
      setHeaderBoxShadow('')
    }
    // gestione header
    if (window.scrollY >= 100) {
      setIsHeaderShrink(true)
    } else {
      setIsHeaderShrink(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  const checkStringInUrl = (word: string) => {
    return window.location.href.includes(word)
  }

  return (
    <div style={{ position: 'relative' }}>
      <header
        style={{
          boxShadow: headerBoxShadow,
          width: '100%',
          position: 'fixed',
          top: '0',
          zIndex: '10',
          backgroundColor: '#fff',
          transition: 'all 0.1s ease-out'
        }}>
        {location.pathname === '/' && !isHeaderShrink && (
          <TopHeader role="region" style={{height: isHeaderShrink ? 0 : 80}} aria-label={"Barra superiore informativa assistenza clienti QuintoPuoi"}>
            <span style={{color: 'white', fontWeight: 'bold', marginRight: '3rem'}}> Assistenza clienti QuintoPuoi </span>
            <GreenNumber href="tel:800124344" aria-label={'Chiama al numero verde 800 124 344'}>
              <span style={{color: 'white'}}>800 124 344</span>
            </GreenNumber>
          </TopHeader>
        )}

        {
          // distinzione tra hamburger menu o menu normale
          isMobile ? (
            <BottomHeaderMobile aria-label={"Barra inferiore contatti QuintoPuoi"}>
              <LogosContainer>
                <Link to="/">
                  <div>
                    <img src={qpLogoRedux} alt="QuintoPuoi, vai alla home" height="30px" style={{ maxWidth: '100%' }} />
                  </div>
                  <div>
                    <img src={bsLogoRedux} alt="" aria-hidden="true" height="10px" style={{ maxWidth: '100%' }} />
                  </div>
                </Link>
              </LogosContainer>
                <OverlayMenu isVisible={isMenuOpen}>
                  <MenuHeader aria-label={"Navigazione Principale"}>
                    <ul
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 0,
                        minWidth: '400px'
                      }}>
                      <BurgerLi>
                        <Link className={checkStringInUrl('quinto-puoi') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('quinto-puoi') ? 'page' : undefined} to="/quinto-puoi">Cessione del Quinto</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('prestitopuoi') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('prestitopuoi') ? 'page' : undefined} to="/prestitopuoi">PrestitoPuoi</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('anticipo-tfs') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('anticipo-tfs') ? 'page' : undefined} to="/anticipo-tfs">Anticipo TFS</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('chi-siamo') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('chi-siamo') ? 'page' : undefined} to="/chi-siamo">Chi siamo</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('la-nostra-rete') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('la-nostra-rete') ? 'page' : undefined} to="/la-nostra-rete">La nostra rete</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('trasparenza') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('trasparenza') ? 'page' : undefined} to="/trasparenza">Trasparenza</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('firma-digitale') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('firma-digitale') ? 'page' : undefined} to="/firma-digitale">Firma Digitale</Link>
                      </BurgerLi>
                      <BurgerLi>
                        <Link className={checkStringInUrl('assistenza') ? 'current-header-tab' : ''} aria-current={checkStringInUrl('assistenza') ? 'page' : undefined}  to="/assistenza">Assistenza</Link>
                      </BurgerLi>
                      <BurgerLi
                        style={{
                          borderRadius: '100px',
                          backgroundColor: 'rgb(252, 187, 0)',
                          padding: '13px 20px'
                        }}>
                        <Link to="/preventivatore">Chiedi un preventivo gratuito</Link>
                      </BurgerLi>
                    </ul>
                  </MenuHeader>
                </OverlayMenu>

              <BurgerMenuOpener>
                <FontAwesomeIcon
                  onClick={openHamburgerMenu}
                  icon={isMenuOpen ? faClose : faBars}
                  style={isMenuOpen ? {
                    cursor: 'pointer',
                    backgroundColor: '#AEAEAE',
                    borderRadius: '50%',
                    width: '2.5rem',
                    height: '2.5rem',
                    color: '#ffffff',
                    padding: '10px'
                  }: {
                    cursor: 'pointer',
                    backgroundColor: '#fcbb00',
                    borderRadius: '50%',
                    width: '2.5rem',
                    height: '2.5rem',
                    color: '#ffffff',
                    padding: '10px'
                  }}
                />
              </BurgerMenuOpener>
            </BottomHeaderMobile>
          ) : (
            <BottomHeader
                role={"region"}
                aria-label={"Barra inferiore contatti QuintoPuoi"}
              style={{
                height: isHeaderShrink ? '7.4rem' : '12.8rem',
                borderTop: isHeaderShrink ? '4px solid #222' : ''
              }}>
              <ImgDiv>
                <Link to="/">
                  {isHeaderShrink ? (
                    <img
                      src={qpLogoRedux}
                      alt="QuintoPuoi, vai alla home"
                      style={{
                        maxWidth: '100%'
                      }}
                    />
                  ) : (
                    <img
                      src={qpLogo}
                      alt="QuintoPuoi, vai alla home"
                      style={{
                        maxWidth: '100%'
                      }}
                    />
                  )}
                </Link>
              </ImgDiv>
              <MenuHeader aria-label={"Navigazione Principale"}>
                <LinksContainer>
                  <ul
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: 0
                    }}
                    className="center-items">
                    <Li className={checkStringInUrl('quinto-puoi') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('quinto-puoi') ? 'page' : undefined}
                        to="/quinto-puoi">
                        Cessione del Quinto
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('prestitopuoi') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('prestitopuoi') ? 'page' : undefined}
                        to="/prestitopuoi">
                        PrestitoPuoi
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('anticipo-tfs') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('anticipo-tfs') ? 'page' : undefined}
                        to="/anticipo-tfs">
                        Anticipo TFS
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('chi-siamo') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('chi-siamo') ? 'page' : undefined}
                        to="/chi-siamo">
                        Chi siamo
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('la-nostra-rete') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('la-nostra-rete') ? 'page' : undefined}
                        to="/la-nostra-rete">
                        La nostra rete
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('trasparenza') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('trasparenza') ? 'page' : undefined}
                        to="/trasparenza">
                        Trasparenza
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('firma-digitale') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('firma-digitale') ? 'page' : undefined}
                        to="/firma-digitale">
                        Firma Digitale
                      </Link>
                    </Li>
                    <Li className={checkStringInUrl('assistenza') ? 'current-header-tab' : ''}>
                      <Link
                        style={{ fontSize: '1.75rem' }}
                        aria-current={checkStringInUrl('assistenza') ? 'page' : undefined}
                        to="/assistenza">
                        Assistenza
                      </Link>
                    </Li>
                    <Li>
                      <Link style={quoteLinkStyle} to="/preventivatore">
                        Chiedi un preventivo gratuito
                      </Link>
                    </Li>
                  </ul>
                </LinksContainer>
              </MenuHeader>
              <ImgDiv>
                <a href="https://bancasistema.it/">
                  {isHeaderShrink ? (
                    <img
                      src={bsLogoRedux}
                      alt="Banca Sistema, vai al sito"
                      style={{
                        maxWidth: '100%'
                      }}
                    />
                  ) : (
                    <img
                      src={bsLogo}
                      alt="Banca Sistema, vai al sito"
                      style={{
                        maxWidth: '100%'
                      }}
                    />
                  )}
                </a>
              </ImgDiv>
            </BottomHeader>
          )
        }
      </header>
    </div>
  )
}

export default Header

//region Style
const quoteLinkStyle = {
  color: 'inherit',
  backgroundColor: '#FCBB00',
  fontWeight: '700',
  textDecoration: 'none',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.1s ease-out',
  fontSize: '1.75rem',
  borderRadius: '2.3rem',
  minHeight: '4.6rem',
  padding: '1rem 2rem 1rem 2rem',
  letterSpacing: '1px',
  flex: 'auto'
}

const ImgDiv = styled.div`
  display: -ms-flexbox;
  display: flex;
  width: auto;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  padding: 0 2rem;
  -ms-flex-align: center;
  align-items: center;
`

const TopHeader = styled.div`
  position: relative;
  width: 100%;
  background-color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.1s ease-out;
  & a {
    color: #fcbb00;
    font-size: 16px;
    font-weight: bolder;
  }
`

const BottomHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: all 0.1s ease-out;
`

const BottomHeaderMobile = styled.div`
  position: relative;
  margin-top: 10px;
  display: grid;
  grid-template-rows: auto;
`

const MenuHeader = styled.nav`
  & ul {
    list-style: none;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }
  & li {
    color: #222;
    padding: 0 0.9rem;
    font-size: 1.3rem;
    line-height: 1.2;
    font-weight: 900;
    letter-spacing: 1px;
  }
  & a {
    text-decoration: none;
    color: #222;
  }
`

const LogosContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`

/**
 * A pannello chiuso serve `visibility: hidden`, non solo `opacity: 0`.
 *
 * Con la sola opacita' i 9 link del menu restano nell'ordine di tabulazione e
 * nell'albero accessibile: chi naviga da tastiera entra in un menu che non
 * vede, e uno screen reader annuncia voci che non ci sono (3V1QQ, WCAG 1.3.1 e
 * 2.4.3). Misurato: 9 stop di Tab dentro il pannello chiuso.
 *
 * `visibility` sta dentro il `transition: all` qui sotto, quindi il passaggio a
 * hidden avviene alla fine della dissolvenza e la resa non cambia.
 */
const OverlayMenu = styled.div<any>`
  ${props => props.isVisible
    ? 'opacity: 1; visibility: visible;'
    : 'pointer-events: none; opacity: 0!important; visibility: hidden;'};
  transition: all 0.1s ease-out;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const LinksContainer = styled.div`
  text-transform: uppercase;
  display: flex;
  flex-wrap: nowrap;
  width: auto;
  flex: 1 1 auto;
  transition: all 0.1s ease-out;
  justify-content: center;
`
const Li = styled.li`
  a {
    font-size: 1.3rem !important;
  }
  white-space: nowrap;
  flex: auto;
  padding-right: 20px;
`
const BurgerLi = styled.li`
  text-transform: uppercase;
  margin: 1.5rem 0;
  display: block;
  padding-right: 0;
  color: #222;
  padding: 0 0.9rem;
  a {
    font-size: 1.3rem !important;
    line-height: 1;
  }
  line-height: 1.2;
  font-weight: 900;
  letter-spacing: 1px;
`
const BurgerMenuOpener = styled.div`
  z-index: 1000;
  position: absolute;
  right: 10%;
  transition: 'all 0.1s ease-out'
`
const GreenNumber = styled.a`
  background-image: url(${greenNumberIcon});
  padding: 42px 8px 8px 25px;
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  font-size: 33px;
  font-weight: bold;
  text-decoration: none;
  color: #222;
  width: 15rem;
  height: 10rem;
  background-size: 15rem;
`;
//endregion
